<div mat-dialog-title>
  @if (showExplain) {
    <div>Verifying {{data.number}}</div>
  }
</div>
<div mat-dialog-content id='smsPanel'>
  @if (showExplain) {
    <div class="fx-col">
      <div>
        A confirmation code has been sent to this number (valid for 2 minutes). Please enter the code in the box below, and click submit to continue.
      </div>
      <mat-form-field class="fx-flex-in-col" appearance="outline">
        <mat-label translate="unifiedapplication_confirmation_code"></mat-label>
        <input name="confirmationCode" matInput [(ngModel)]="confirmationCode"
          nospaceallow="true" validate NOunderscore="true" validname="true">
        @if (showErrorConfirmationCode) {
          <div>
            <small class="help-block has-errors">{{confirmationCodeErrorMessage}}</small>
          </div>
        }
      </mat-form-field>
      <div class="smsInputButton">
        <input name="submitConfirmationCode" matInput type="submit" (click)="checkConfirmationCode();">
      </div>
    </div>
  }

  @if (showExplain && enableResend) {
    If you have not received the Text message within 2
    minutes, check the accuracy of the phone number you provided or click <a
  (click)="verifySmsbylink(data.number)" style="color: var(--theme-deafult-secondary);">here</a> to resend
  the verification message.
}
@if (showExplain) {
  <section class="txt-center">
    <img style="width: 200px;" src="../../../../assets/images/ezgif.com-gif-maker.gif">
  </section>
}
@if (showExplain) {
  <div [mat-dialog-close]="true" class="smsInputButton">Close</div>
}
@if (smsVerified && !showExplain) {
  <p>Verified Successfully</p>
  <div [mat-dialog-close]="true" class="smsInputButton">Close</div>
}
</div>